type PedidoComFormaPagamento = {
  forma_pagamento?: string | number | null;
  forma_pagamento_label?: string | null;
  repassar_multa?: boolean | null;
};

function normalizarFormaPagamento(valor?: string | number | null): string {
  return String(valor ?? "").trim().toLowerCase();
}

export function isFormaPagamentoFaturadoOuDinheiro(
  pedido?: PedidoComFormaPagamento | null
): boolean {
  const formas = [
    normalizarFormaPagamento(pedido?.forma_pagamento),
    normalizarFormaPagamento(pedido?.forma_pagamento_label),
  ];

  return formas.some((forma) => ["1", "dinheiro", "faturado"].includes(forma));
}

export function isMultaNaFatura(
  pedido?: PedidoComFormaPagamento | null,
  repassarMultaFallback = false
): boolean {
  const repassarMulta = Boolean(pedido?.repassar_multa ?? repassarMultaFallback);

  return repassarMulta && isFormaPagamentoFaturadoOuDinheiro(pedido);
}
